export const RATING_LABELS = [' оценка', ' оценки', ' оценок'];
export const DEFAULT_APPS_TITLE = 'RuStore — Каталог приложений для Android';
export const DEFAULT_GAMES_TITLE = 'RuStore — Каталог игр для Android';
export const DEFAULT_VK_MINI_APPS_TITLE =
  'RuStore — Каталог VK mini apps для Android';

export const DEFAULT_DESCRIPTION =
  // eslint-disable-next-line max-len
  'RuStore — это Российский магазин мобильных Android-приложений, которые отвечают стандартам качества, конфиденциальности и защиты данных';
export const DEFAULT_GAMES_DESCRIPTION =
  'Игры в RuStore — популярные мобильные игры в Российском магазине мобильных Android-приложений';

export const DEFAULT_KIOSK_DESCRIPTION =
  'Хочешь играть в зарубежные игры? Купи игровую валюту и пополни счет через Киоск RuStore. Широкий выбор игр, удобные способы оплаты, быстрая доставка ваучеров.';
export const DEFAULT_KIOSK_TITLE =
  'Пополнение счета в играх Steam, Fortnite, PUBG, Mobile Legends, Roblox в Киоске RuStore – быстро и безопасно';

export const ScreenshotTab = {
  TABLET: 'TABLET',
  MOBILE: 'MOBILE',
  TV: 'TV',
} as const;

export const DOMAIN = 'https://www.rustore.ru/catalog';

export const DEFAULT_OG_IMAGE =
  'https://static.rustore.ru/image/rustore_deeplink_600x315.jpg';

export const DEFAULT_SITE_NAME = 'RuStore';

export const VIDEO_URL = 'https://vk.com/video_ext.php';

export const INTERESTING_TITLE = 'Интересное';

export const ALL_APPS_TITLE = 'Все приложения';

export const ALL_GAMES_TITLE = 'Все игры';

export const TV_PAGE_TITLE = 'Приложения для ТВ';

export const APP_STUBS_SITEMAP_CHUNK_ID = 'stubs';
